export default "__VITE_ASSET__C5TN5O6I__"